import { render, staticRenderFns } from "./CapturaDocumentosFotoSelfie.vue?vue&type=template&id=05658b9c&scoped=true&"
import script from "./CapturaDocumentosFotoSelfie.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentosFotoSelfie.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentosFotoSelfie.vue?vue&type=style&index=0&id=05658b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05658b9c",
  null
  
)

export default component.exports